export enum BaseRoute {
  HOME = "/",
  SCHEDULE = "/schedule",
  PROFILE = "/profile",
  AUTH = "/auth",
  DOCUMENTS = "/documents",
  HELP = "/help",
  BADGE = "/badge",
  SPONSOR = "/sponsor",
  HACKER = "/hacker",
  PLAYGROUND = "/playground",
  NOT_FOUND = "/404",
  MENTOR = "/mentor",
  CONNECT_SLACK_ACCOUNT = "/link",
  VOLUNTEER = "/volunteer",
  NETWORKING_RESULT = "/qr/2026",
  NETWORKING = "/networking",
  SETTINGS = "/settings",
  ACCOUNT = "/account",
  SIGNAGE_HUNT = "/signage-hunt",
  REGISTER = "/register",
  TICKET = "/ticket",
  HARDWARE = "/hardware",
  GOOSE_GAMES = "/goose-games",
  HACKER_DIRECTORY = "/hacker-directory",
}

export enum DocumentRoute {
  CODE_OF_CONDUCT = "code-of-conduct",
  PRIVACY_POLICY = "privacy-policy",
  TERMS_AND_CONDITIONS = "terms-and-conditions",
}

export enum SponsorRoute {
  HOME = "home",
  PERKS = "perks",
  SHIPPED_SWAG = "shipped-swag",
  RECRUITMENT = "recruitment",
  POST_EVENT_REPORT = "post-event-report",
  PLATFORM_ONBOARDING = "platform-onboarding",
}

export enum HackerRoute {
  RSVP = "rsvp",
  TRAVEL_SUPPORT = "travel-support",
  PERSONAL = "personal",
  TRAVEL = "travel",
  EVENT = "event",
  BADGE = "badge",
  CAREER = "career",
  PROFILE = "profile",
  CONFIRMATION = "confirmation",
  TRAVEL_DETAILS = "travel-details",
  GRAPHIC = "graphic",
  HOME = "home",
  MENTORSHIP = "mentorship",
  WELCOME_BOOKLET = "welcome-booklet",
  MENTOR_CAFE = "mentor-cafe",
  GETTING_STARTED = "getting-started",
  JUDGING = "judging",
  JUDGING_INFO = "judging/info",
  JUDGING_MUSEUM = "judging/museum",
  JUDGING_PRIZEHUB = "judging/prizehub",
  JUDGING_FAQ = "judging/faq",
  FAQ = "faq",
}

export enum BadgeRoute {
  CONNECT = "connect",
  MY_BADGE = "my-badge",
  SYNC = "sync",
  ADMIN_SYNC = "admin-sync",
}

export enum HardwareRoute {
  HOME = "home",
  INVENTORY = "inventory",
  REQUEST_HISTORY = "request-history",
  USERS = "users",
  LOTTERY = "lottery",
  FAQ = "faq",
}

export enum MentorRoute {
  HOME = "home",
  REQUESTS = "requests",
  CLAIMED_REQUESTS = "claimed-requests",
  PROFILE = "profile",
  SHIFTS = "shifts",
  SHIFT_SCHEDULE = "shift-schedule",
  ADD_SHIFT = "shifts/add",
  EDIT_SHIFT = "shifts/edit",
}

export enum VolunteerRoute {
  HOME = "home",
  SHIFT_SCHEDULE = "shift-schedule",
  SHIFTS = "shifts",
  CHECK_IN = "check-in",
  VOLUNTEERS = "volunteers",
  ADD_SHIFT = "shifts/add",
  EDIT_SHIFT = "shifts/edit",
  CONTACT = "contact",
  REGISTRATION = "registration",
  EVENT_REDEMPTION = "event-redemption",
  UPLOAD_SHEET = "shifts/upload",
  PROFILE = "profile",
  BUFFER_INFORMATION = "buffer-information",
}

export enum GooseGamesRoute {
  HOME = "home",
  QUESTS = "quests",
  STORE = "store",
  HACKERS = "hackers",
}

export enum SignageHuntRoute {
  SPACE = "space",
}

export enum HackerDirectoryRoute {
  HOME = "home",
  DIRECTORY = "directory",
  PROFILE = "profile",
  YOUR_PROFILE = "your-profile",
}

// includes all valid routes
// Not allowed to be an enum for now :(( https://github.com/microsoft/TypeScript/issues/40793
export const Route = {
  HOME: BaseRoute.HOME,
  SCHEDULE: BaseRoute.SCHEDULE,
  PROFILE: BaseRoute.PROFILE,
  AUTH: BaseRoute.AUTH,
  DOC_COC: `${BaseRoute.DOCUMENTS}/${DocumentRoute.CODE_OF_CONDUCT}`,
  DOC_TAC: `${BaseRoute.DOCUMENTS}/${DocumentRoute.TERMS_AND_CONDITIONS}`,
  DOC_PRIVACY: `${BaseRoute.DOCUMENTS}/${DocumentRoute.PRIVACY_POLICY}`,
  HELP: BaseRoute.HELP,
  NETWORKING: BaseRoute.NETWORKING,
  ACCOUNT: BaseRoute.ACCOUNT,

  BADGE_CONNECT: `${BaseRoute.BADGE}/${BadgeRoute.CONNECT}`,
  BADGE_SYNC: `${BaseRoute.BADGE}/${BadgeRoute.SYNC}`,
  BADGE_ADMIN_SYNC: `${BaseRoute.BADGE}/${BadgeRoute.ADMIN_SYNC}`,
  BADGE_MY_BADGE: `${BaseRoute.BADGE}/${BadgeRoute.MY_BADGE}`,

  SPONSOR_HOME: `${BaseRoute.SPONSOR}/${SponsorRoute.HOME}`,
  SPONSOR_PERKS: `${BaseRoute.SPONSOR}/${SponsorRoute.PERKS}`,
  SPONSOR_SHIPPED_SWAG: `${BaseRoute.SPONSOR}/${SponsorRoute.SHIPPED_SWAG}`,
  SPONSOR_RECRUITMENT: `${BaseRoute.SPONSOR}/${SponsorRoute.RECRUITMENT}`,
  SPONSOR_POST_EVENT_REPORT: `${BaseRoute.SPONSOR}/${SponsorRoute.POST_EVENT_REPORT}`,
  // SPONSOR_PLATFORM_ONBOARDING: `${BaseRoute.SPONSOR}/${SponsorRoute.PLATFORM_ONBOARDING}`,

  MENTOR_HOME: `${BaseRoute.MENTOR}/${MentorRoute.HOME}`,
  MENTOR_REQUESTS: `${BaseRoute.MENTOR}/${MentorRoute.REQUESTS}`,
  MENTOR_CLAIMED_REQUESTS: `${BaseRoute.MENTOR}/${MentorRoute.CLAIMED_REQUESTS}`,
  MENTOR_PROFILE: `${BaseRoute.MENTOR}/${MentorRoute.PROFILE}`,
  MENTOR_SHIFTS: `${BaseRoute.MENTOR}/${MentorRoute.SHIFTS}`,
  MENTOR_SHIFT_SCHEDULE: `${BaseRoute.MENTOR}/${MentorRoute.SHIFT_SCHEDULE}`,

  HACKER_RSVP: `${BaseRoute.HACKER}/${HackerRoute.RSVP}`,
  HACKER_TRAVEL_SUPPORT: `${BaseRoute.HACKER}/${HackerRoute.TRAVEL_SUPPORT}`,
  HACKER_PERSONAL: `${BaseRoute.HACKER}/${HackerRoute.PERSONAL}`,
  HACKER_TRAVEL: `${BaseRoute.HACKER}/${HackerRoute.TRAVEL}`,
  HACKER_EVENT: `${BaseRoute.HACKER}/${HackerRoute.EVENT}`,
  HACKER_BADGE: `${BaseRoute.HACKER}/${HackerRoute.BADGE}`,
  HACKER_CAREER: `${BaseRoute.HACKER}/${HackerRoute.CAREER}`,
  HACKER_PROFILE: `${BaseRoute.HACKER}/${HackerRoute.PROFILE}`,
  HACKER_CONFIRMATION: `${BaseRoute.HACKER}/${HackerRoute.CONFIRMATION}`,
  HACKER_TRAVEL_DETAILS: `${BaseRoute.HACKER}/${HackerRoute.TRAVEL_DETAILS}`,
  HACKER_GRAPHIC: `${BaseRoute.HACKER}/${HackerRoute.GRAPHIC}`,

  HACKER_HOME: `${BaseRoute.HACKER}/${HackerRoute.HOME}`,
  HACKER_WELCOME_BOOKLET: `${BaseRoute.HACKER}/${HackerRoute.WELCOME_BOOKLET}`,

  HACKER_MENTORSHIP: `${BaseRoute.HACKER}/${HackerRoute.MENTORSHIP}`,
  HACKER_MENTOR_CAFE: `${BaseRoute.HACKER}/${HackerRoute.MENTOR_CAFE}`,

  HACKER_GETTING_STARTED: `${BaseRoute.HACKER}/${HackerRoute.GETTING_STARTED}`,
  HACKER_JUDGING: `${BaseRoute.HACKER}/${HackerRoute.JUDGING}`,
  HACKER_JUDGING_INFO: `${BaseRoute.HACKER}/${HackerRoute.JUDGING_INFO}`,
  HACKER_JUDGING_MUSEUM: `${BaseRoute.HACKER}/${HackerRoute.JUDGING_MUSEUM}`,
  HACKER_JUDGING_PRIZEHUB: `${BaseRoute.HACKER}/${HackerRoute.JUDGING_PRIZEHUB}`,
  HACKER_JUDGING_FAQ: `${BaseRoute.HACKER}/${HackerRoute.JUDGING_FAQ}`,
  HACKER_FAQ: `${BaseRoute.HACKER}/${HackerRoute.FAQ}`,
  // HACKER_HARDWARE_HOME: `${BaseRoute.HACKER}/${HackerRoute.HARDWARE_ITEMS}`,
  // HACKER_HARDWARE_INSTRUCTIONS: `${BaseRoute.HACKER}/${HackerRoute.HARDWARE_INSTRUCTIONS}`,
  // HACKER_HARDWARE_REQUESTS: `${BaseRoute.HACKER}/${HackerRoute.HARDWARE_REQUESTS}`,

  VOLUNTEER_HOME: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.HOME}`,
  VOLUNTEER_SHIFT_SCHEDULE: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.SHIFT_SCHEDULE}`,
  VOLUNTEER_REGISTRATION: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.REGISTRATION}`,
  VOLUNTEER_EVENT_REDEMPTION: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.EVENT_REDEMPTION}`,
  VOLUNTEER_SHIFTS: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.SHIFTS}`,
  VOLUNTEER_CHECK_IN: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.CHECK_IN}`,
  VOLUNTEER_VOLUNTEERS: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.VOLUNTEERS}`,
  VOLUNTEER_CONTACT: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.CONTACT}`,
  VOLUNTEER_PROFILE: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.PROFILE}`,
  VOLUNTEER_BUFFER_INFORMATION: `${BaseRoute.VOLUNTEER}/${VolunteerRoute.BUFFER_INFORMATION}`,

  HARDWARE_HOME: `${BaseRoute.HARDWARE}/${HardwareRoute.HOME}`,
  HARDWARE_INVENTORY: `${BaseRoute.HARDWARE}/${HardwareRoute.INVENTORY}`,
  HARDWARE_REQUEST_HISTORY: `${BaseRoute.HARDWARE}/${HardwareRoute.REQUEST_HISTORY}`,
  HARDWARE_USERS: `${BaseRoute.HARDWARE}/${HardwareRoute.USERS}`,
  HARDWARE_LOTTERY: `${BaseRoute.HARDWARE}/${HardwareRoute.LOTTERY}`,
  HARDWARE_FAQ: `${BaseRoute.HARDWARE}/${HardwareRoute.FAQ}`,

  GOOSE_GAMES_HOME: `${BaseRoute.GOOSE_GAMES}/${GooseGamesRoute.HOME}`,
  GOOSE_GAMES_QUESTS: `${BaseRoute.GOOSE_GAMES}/${GooseGamesRoute.QUESTS}`,
  GOOSE_GAMES_STORE: `${BaseRoute.GOOSE_GAMES}/${GooseGamesRoute.STORE}`,
  GOOSE_GAMES_HACKERS: `${BaseRoute.GOOSE_GAMES}/${GooseGamesRoute.HACKERS}`,

  HACKER_DIRECTORY_HOME: `${BaseRoute.HACKER_DIRECTORY}/${HackerDirectoryRoute.HOME}`,
  HACKER_DIRECTORY_DIRECTORY: `${BaseRoute.HACKER_DIRECTORY}/${HackerDirectoryRoute.DIRECTORY}`,
  HACKER_DIRECTORY_PROFILE: `${BaseRoute.HACKER_DIRECTORY}/${HackerDirectoryRoute.PROFILE}`,
  HACKER_DIRECTORY_YOUR_PROFILE: `${BaseRoute.HACKER_DIRECTORY}/${HackerDirectoryRoute.YOUR_PROFILE}`,

  PLAYGROUND: BaseRoute.PLAYGROUND,
  NOT_FOUND: BaseRoute.NOT_FOUND,

  SIGNAGE_HUNT: BaseRoute.SIGNAGE_HUNT,
  REGISTER: BaseRoute.REGISTER,
  TICKET: BaseRoute.TICKET,
};
